
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    Swiper,
    SwiperSlide,
  }
})
export default class  extends Vue {
  @Prop() data!: any;

  swiperOptions: any = {
    effect: 'fade',
    pagination: {
      el: '.swiper-pagination',
    },
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    }
  }
}
